export default __webpack_public_path__ + "static/media/m-app.4a931608.png";